<template>
    <div class="s-layer">
        <form onsubmit="return false">
            <div class="form-bar box box-center">
                <div class="input-bar">
                    <input type="text" name="keyword" v-model.trim.lazy="keyword"  placeholder="请输入搜索内容" class="s-input">
                    <input type="submit" value="搜索" class="s-btn" @click="goSearch">
                </div>
                <a class="close-btn" @click="closeSearch" href="javascript:;">取消</a>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data () {
        return {
        	keyword: ''
        }
    },
    methods: {
    	closeSearch () {
    		this.$emit('closeSearch');
    	},
    	goSearch () {
    		if(this.keyword == ''){
    			return false
    		}
    		this.$router.push({
    			name: 'searchView',
    			params: {
    				keyword: this.keyword
    			}
    		})
    		this.$emit('closeSearch');
    		this.keyword = ''
    	}
    }
}
</script>
<style lang="scss">
.s-layer{
	position:fixed;
	left: 0;
	top:0;
	width:100%;
	height: 100%;
	background: #fff;
	z-index: 999;
	.form-bar{
		height:1.3rem;
		.input-bar{
			background: #f5f5f5;
			padding-left:.5rem;
			border-radius: 20px;
			overflow:hidden;
		}
		input{
			border:none;
			padding:0;
			height:.8rem;
			line-height:.8rem;
			background:none;
			outline:none;
		}
		.s-input{
			width:4.3rem;
		}
		.s-btn{
			padding:0 .2rem;
			font-size: .26rem;
		}
	}
	.close-btn{
		margin-left:.3rem;
		font-size:.26rem;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/search.vue